import { PhoneCall } from "lucide-react";
import Reveal from "@/components/site/Reveal";

export default function CallBanner() {
  return (
    <section data-testid="call-banner" className="relative overflow-hidden border-t border-[#282C34]">
      <div className="hazard h-2.5 w-full" />
      <div className="bg-[#FF5A00]">
        <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-6 px-5 py-12 sm:px-8 md:flex-row">
          <Reveal>
            <p className="text-center font-display text-4xl leading-none tracking-wide text-[#0B0C0E] sm:text-5xl md:text-left">
              NEED IT GONE <span className="text-white">TODAY?</span>
            </p>
            <p className="mt-2 text-center font-mono-ind text-xs uppercase tracking-[0.25em] text-[#0B0C0E]/70 md:text-left">
              Same-day pickup available across Payne, Noble, Pawnee, Creek & Logan counties
            </p>
          </Reveal>
          <Reveal delay={0.1}>
            <a
              href="tel:+19183997313"
              data-testid="call-banner-button"
              className="group flex items-center gap-4 bg-[#0B0C0E] px-8 py-5 font-display text-2xl tracking-widest text-[#FF9F00] transition-transform duration-300 hover:-translate-y-1 active:translate-y-0"
            >
              <PhoneCall className="h-6 w-6 transition-transform duration-300 group-hover:rotate-12" />
              918-399-7313
            </a>
          </Reveal>
        </div>
      </div>
      <div className="hazard h-2.5 w-full" />
    </section>
  );
}
